import { useSessionContext } from '@/features/auth';

export const useIsStaff = (): boolean => {
	return useSessionContext().isStaff;
};
